// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"voice-input_wrapper__0dYSP","convert":"voice-input_convert__UTKVW"};